import * as React from "react"
const Left = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={"100%"}
    height={"100%"}
    x={0}
    y={0}
    style={{
      maxHeight: 500,  
    }}
    viewBox="7.797 4.495 111.15 53.326"
    {...props}
  >
    <style>
      {
        `.st0,.st3,.st4,.st5,.st6,.st7{fill:none;stroke:${props.color};stroke-miterlimit:10}.st3,.st4,.st5,.st6,.st7{stroke-width:.5;stroke-linecap:round;stroke-linejoin:round}.st4,.st5,.st6,.st7{stroke-width:.6}.st5,.st6,.st7{stroke-width:.5;stroke-miterlimit:9.9998}.st6,.st7{stroke-width:.4;stroke-miterlimit:10}.st7{stroke-width:1.3}`
      }
    </style>
    <g id="Rear_Tyre">
      <path
        d="M91.1 33.8C93 32 95.6 31 98.4 31c5.6 0 10.2 4.2 10.9 9.5.1.5.1 1 .1 1.5 0 6.1-4.9 11.1-11.1 11.1-4.6 0-8.5-2.8-10.1-6.7M87.4 41.1c.2-2.1.9-4 2.1-5.6"
        className="st0"
      />
      <path
        d="M87.7 31c2.8-2.7 6.5-4.3 10.7-4.3 8.4 0 15.1 6.8 15.1 15.1S106.8 57 98.4 57c-7 0-12.8-4.7-14.5-11.1M83.3 41.5c0-3.3 1-6.2 2.9-8.7M100.3 53l-1-6.3M98.3 41.2l-1.7-10.1M95.4 46.6 91.8 51M105.8 33.9l-6 7.3M104 46.4l3.3 2.2M89 36.2l7.2 4.8M109.4 40.5l-9.1 1.7"
        className="st0"
      />
      <circle
        cx={98.6}
        cy={42.5}
        r={0.9}
        style={{
          fill: "none",
          stroke: `${props.color}`,
          strokeWidth: 0.25,
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m83.5 45.7.1.5"
        style={{
          fill: "none",
          stroke: `${props.color}`,
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
      />
    </g>
    <g id="Front_Tyre">
      <circle cx={24} cy={42.1} r={11.1} className="st0" />
      <circle cx={24.1} cy={41.9} r={15.1} className="st0" />
      <path
        d="m26 53-1.7-9.5M24 41.7l-1.7-10.4M35.1 40.5l-10 1.9M23.3 42.8l-10 1.8M23.7 43.4 17.4 51M27.9 38.3l-3 3.7M31.5 33.9l-3.6 4.4M33 48.6l-8-5.5M23.4 42.1l-8.7-5.9"
        className="st0"
      />
    </g>
    <g id="Layer_1_00000090260315095264767780000009859085219052019842_">
      <g id="Layer_1_00000010297891498249283530000014231621467975026821_">
        <g id="Front">
          <path
            d="m31.7 27.4-.2.3c-1.5-.8-3.4-1.5-5.6-1.7 2.1-.1 4.1.5 5.8 1.4zM33.4 29l.5.4c1.6 1.2 2.7 2.5 4 4.8M31.7 27.4l-.2.2M38.3 21.4l-.6 1.2c1.9 3.7 0 7.9 0 7.9M42.8 13.8c-.2-.1-.4-.1-.4-.1M44.1 7.7c-.4.6-.3 1.7-.3 1.7-.4-.1-.6-.1-.8 0s-.3.4-.4.7c-.6.1-1.1.3-1.5.4-.8.3-1.4.6-1.4.6.4-.6.9-1.2 1.3-1.7 1.5-1.2 3.1-1.8 3.1-1.7zM77.1 44.1c-.2.5-1.2 1.7-8.4 1.8l-5.2.2c-.7 0-1.8-.8-1.8-.8s-3.3.3-3.6.2c-.3-.1-1.2-.3-1.7-.3s-1.3.4-2.1.4-3.3-1-3.7-1c-.4 0-1.7.1-1.7.1l-3-3.5h-.5c-.5 0-.7-.3-.7-.5v-.8c0-.6.5-.6 1-.6s.6-.3.6-.3-1.3-4.7-2.1-6.5c-.4-2.3-.9-4.1-1.6-5.5h0c-.1-2.1-1-4.6-1.2-4.6-.1 0-.4-.3-.9-.4-.8-.4-1.9-.9-1.9-.9l1-1.9.6-.8 1.3-2.7h0l1.3-1.5c.5.3.4 1.9.5 1.9l-.3.1-.3.9-1.1 2.3.8.4 3.2 11.6s.1.1.2.4c0 .7 1 3.3 1 3.3s0 .8.1 1.9c0 .4.3.6.6.8.3 1.3 1.6 6.9 7.5 6.9 5.3-.4 9.4-.4 11.1-.4h.1c.4.1 1.1.1 1.7.2.4 0 8.1-.4 9.2-.4z"
            className="st3"
          />
          <path
            d="m46.5 8.7-.7 1.1.3.3-.3.3c-.5-.4-1.2-.6-1.8-.8-.1 0-.2-.1-.3-.1 0 0-.1-1.1.3-1.7.1-.2.2-.3.4-.4 0-.1.1-.1.2-.1l2-.1c-.4.6-.4 1.4-.1 1.5z"
            className="st3"
          />
          <path
            d="M51.2 9.2c-.4-.1-1.1-.1-1.7-.3-.4-.2-2.4-.1-2.8-.4-.2-.1-.4-1.3.2-1.3 0 0 2.3-.1 2.7 0 .5.2 1.2.4 1.8.4.4 0 .5 1.7-.2 1.6z"
            className="st3"
          />
          <path d="m33.6 28.6-9 15.6-2-1.1 9.1-15.6 1.9 1.1z" className="st4" />
          <path
            d="m41 14.5-1.9 3.2-.3.9-.6 1.5c-.2.4-.8-.4-1.2-.6h-.2s-.3.1-.1-.2l.7-1.5 1.7-3.2.8-.1 2.3-.8-1.2.8zM32 26.8l-.1.2-.3.4c-1.7-.9-3.7-1.3-5.7-1.4-.8-.1-1.6-.1-2.5-.2 0 0-.9-.4-2.1-1.1 0 0 5.8-1.7 11.3 1.4l-.6.7zM40.7 38.5s-.7-.2-1.3-.9c0 0-.4-1.5-1.3-3.3-1-2.5-2.7-4.7-4.9-6l.5.2V28l.6-.8c.4.4.8.7 1.3 1.1.8.8 1.5 1.5 2 2.3 2.5 3.5 3 6.6 3.1 7.9z"
            className="st3"
          />
          <path d="M38.6 15.6c-.1-2.5.5-4.5 1.3-4.5" className="st3" />
          <path
            strokeWidth={0.49999}
            d="m31.556 27.965 1.4-2.425 1.56.9-1.4 2.425zM35.697 21.248l1-1.732 1.472.85-1 1.732z"
            className="st5"
          />
          <path
            d="M36.8 22.7 35 25.9c-.1.2-.4.3-.6.2l-.8-.5c-.2-.1-.3-.4-.2-.6l1.8-3.2c.1-.2.4-.3.6-.2l.8.5c.2.1.3.4.2.6z"
            className="st3"
          />
        </g>
        <g id="Rear">
          <path
            d="M86.7 30.3c0 .9-.4 1.6-1.2 1.6M88.3 31.6c0 .8-.5 1.3-1.4 1.5M95.3 37.2c-.1.9-.5 1.7-1.3 1.9M93.6 35.8c0 .9-.6 1.4-1.4 1.6M91.7 34.3c0 .9-.5 1.6-1.3 1.7M89.7 32.8c0 .9-.5 1.6-1.4 1.6"
            className="st6"
          />
          <path
            d="m96.3 40 1.4 1.1M96.8 39.5l1.8 1.5M88.5 25.5c10.3-6.4 20.4-1.7 24.5 8.3"
            className="st3"
          />
          <path
            d="M87.4 25.5c8-8.5 25.3-3.8 26.9 8.2M114.3 33.8c0 .1-.7 0-1.2 0M117.6 31c0 1.1-2.3 2.7-3.3 2.8"
            className="st3"
          />
          <path
            d="M94.9 26.5c-2.6 0-4.7.9-5.8.9-.3 0-1.2.4-1.3.4-.4 0-1.1.7-1.9 1.3-.3.2-.8.6-1.1.9.2-.2.3-.4.2-.8 0-.6-.4-1.1-1.1-1.1-.7 0-1 .4-1 1.1 0 .6.4 1.1 1.1 1.1.3 0 .8-.2 1-.4-.1.1-.5.3-.6.5l-3 .1c.4-1 .7-1.8.9-2.5 1.8-.3 4.1-1.6 5.1-2.5l1.2-.3 15.1-.3c.1.1 0 .9 0 1.4 0 .2-7.1.1-8.8.2"
            className="st4"
          />
          <path d="M77.2 44.2c.9.3 1.8-.6 3.3-.6" className="st6" />
          <path
            d="M84.4 30.4c-.3.3-.6.7-.9 1-1 1.4-2 6.4-1.8 9.6h-1.8s-.2-6.5.7-9c.4-1 .6-1 .8-1.6-.1.1 3 0 3 0z"
            className="st4"
          />
          <path
            d="m86.2 32.7 9.2 7.7c.8-.1.9-.4 1.2-.7.1-.1.2-.3.3-.4.2-.3.2-.8 0-1l-11.4-8.9-.7.3-.7-.8-.6.3.9 1.3-.4.3 2.2 1.9"
            className="st6"
          />
          <path
            d="m99.3 46.7-3.9-.1M98.7 43.8h3.6c.9 0 1.7 0 1.7.5v1.4c0 1-1.4.9-3.2.9h-1.6M88.3 46.4H86c-.8 0-1.6-.2-2.3-.6l-3.1-1.9v-.4l7 .1M95.4 46.6l-7.1-.2"
            className="st3"
          />
          <path
            d="M96.5 41.2h2c.9 0 1.7 0 1.7.4V43c0 .8-1.4.8-3.3.8l-15.6-.3c-.9 0-1.7-.2-2.4-.5l-3.2-1.7h11.5M87.4 41.2h9"
            className="st3"
          />
        </g>
      </g>
      <path d="m29.3 31.4-3.9 7M31.5 32.3l-3.8 6.5" className="st7" />
    </g>
  </svg>
)
export default Left
